import type { ZodObject, ZodRawShape } from "zod";
import { ContentType } from "./ContentType.js";
import { ckEditorBlockSchema } from "./content-blocks/ckEditorBlockSchema.js";
import { leadParagraphBlockSchema } from "./content-blocks/leadParagraphBlockSchema.js";
import { quoationBlockSchema } from "./content-blocks/quotationBlockSchema.js";
import { unorderedListBlockSchema } from "./content-blocks/unorderedListBlockSchema.js";

export const contentBlockSchemaMap = {
	[ContentType.CKEditor]: ckEditorBlockSchema,
	[ContentType.Quotation]: quoationBlockSchema,
	[ContentType.UnorderedList]: unorderedListBlockSchema,
	[ContentType.LeadParagraph]: leadParagraphBlockSchema,
} satisfies Record<ContentType, ZodObject<ZodRawShape>>;
